import { z } from 'zod';
import { ERROR_MESSAGES, MIN_PASSWORD_LENGTH } from '@/lib/utils/constants';

/**
 * Schemas de validación para autenticación
 */

export const loginSchema = z.object({
  email: z.string().min(1, ERROR_MESSAGES.REQUIRED).email(ERROR_MESSAGES.INVALID_EMAIL),
  password: z.string().min(1, ERROR_MESSAGES.REQUIRED),
});

export const registerSchema = z
  .object({
    // Datos de empresa
    companyName: z
      .string()
      .min(2, ERROR_MESSAGES.MIN_LENGTH(2))
      .max(100, ERROR_MESSAGES.MAX_LENGTH(100)),
    taxId: z.string().min(5, ERROR_MESSAGES.MIN_LENGTH(5)).max(50, ERROR_MESSAGES.MAX_LENGTH(50)),
    companyEmail: z.string().min(1, ERROR_MESSAGES.REQUIRED).email(ERROR_MESSAGES.INVALID_EMAIL),
    companyPhone: z
      .string()
      .min(7, ERROR_MESSAGES.MIN_LENGTH(7))
      .max(20, ERROR_MESSAGES.MAX_LENGTH(20)),

    // Datos de usuario
    firstName: z
      .string()
      .min(2, ERROR_MESSAGES.MIN_LENGTH(2))
      .max(50, ERROR_MESSAGES.MAX_LENGTH(50)),
    lastName: z
      .string()
      .min(2, ERROR_MESSAGES.MIN_LENGTH(2))
      .max(50, ERROR_MESSAGES.MAX_LENGTH(50)),
    email: z.string().min(1, ERROR_MESSAGES.REQUIRED).email(ERROR_MESSAGES.INVALID_EMAIL),
    password: z.string().min(MIN_PASSWORD_LENGTH, ERROR_MESSAGES.MIN_LENGTH(MIN_PASSWORD_LENGTH)),
    confirmPassword: z.string().min(1, ERROR_MESSAGES.REQUIRED),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: ERROR_MESSAGES.PASSWORDS_DONT_MATCH,
    path: ['confirmPassword'],
  });

export const forgotPasswordSchema = z.object({
  email: z.string().min(1, ERROR_MESSAGES.REQUIRED).email(ERROR_MESSAGES.INVALID_EMAIL),
});

export const resetPasswordSchema = z
  .object({
    password: z.string().min(MIN_PASSWORD_LENGTH, ERROR_MESSAGES.MIN_LENGTH(MIN_PASSWORD_LENGTH)),
    confirmPassword: z.string().min(1, ERROR_MESSAGES.REQUIRED),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: ERROR_MESSAGES.PASSWORDS_DONT_MATCH,
    path: ['confirmPassword'],
  });

export type LoginFormData = z.infer<typeof loginSchema>;
export type RegisterFormData = z.infer<typeof registerSchema>;
export type ForgotPasswordFormData = z.infer<typeof forgotPasswordSchema>;
export type ResetPasswordFormData = z.infer<typeof resetPasswordSchema>;
